export default {
    name: 'LegacyRepositoryApp'
};
